import { render, staticRenderFns } from "./mc-serve.tests.vue?vue&type=template&id=70b9882a&scoped=true"
import script from "./mc-serve.tests.vue?vue&type=script&lang=ts"
export * from "./mc-serve.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b9882a",
  null
  
)

export default component.exports